export var LIBRARY_NOTE_MAX_LENGTH = 2000;
export var LIBRARY_NOTE_WARNING_THRESHOLD = LIBRARY_NOTE_MAX_LENGTH - 100;
